/* =========================================
   Initialization
   ========================================= */
document.addEventListener('DOMContentLoaded', () => {
  initLoading();
  initScrollAnimations();
  initHeaderScroll();
  initHamburger();
  initSmoothScroll();
  initCarousel();
  initHeroImageSwitch();
  initParallax();

  if (document.querySelector('.cart-page')) {
    updateCartCalculations();
    initAutoCartUpdate();
  }
});

/* =========================================
   Global Functions
   ========================================= */

function selectOption(btn) {
  const allBtns = document.querySelectorAll('.option-btn');
  allBtns.forEach(b => b.classList.remove('is-active'));
  btn.classList.add('is-active');

  const price = btn.getAttribute('data-price');
  const priceDisplay = document.getElementById('js-price-display');
  if (price && priceDisplay) {
    priceDisplay.innerHTML = `<span class="price-val">¥${Number(price).toLocaleString()}</span><span class="price-tax">(税込)</span>`;
  }
}

function changeCartQty(btn, change) {
  const wrapper = btn.closest('.quantity-selector');
  const input = wrapper.querySelector('input');
  let val = parseInt(input.value);
  val += change;
  if (val < 1) val = 1; // 数量は1未満にならないようにする
  input.value = val;
  updateCartCalculations();

  // ▼ 以下の1行を追記：数値を変更した後に「変更された」というイベントを発生させ、自動更新をトリガーする
  input.dispatchEvent(new Event('change'));
}

function removeCartItem(btn) {
  const item = btn.closest('.cart-item');
  if (item) {
    item.remove();
    updateCartCalculations();
  }
}

function addSparklingToCart() {
  const cartItemsContainer = document.querySelector('.cart-items');
  const targetId = 'sparkling-2023';
  // 既にカートにあるかチェック
  const existingItem = document.querySelector(`.cart-item[data-id="${targetId}"]`);

  if (existingItem) {
    const input = existingItem.querySelector('.js-cart-qty');
    input.value = parseInt(input.value) + 1;
    // 既存アイテムまでスクロールして強調
    existingItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
    existingItem.style.backgroundColor = '#fff5f5';
    setTimeout(() => { existingItem.style.backgroundColor = ''; }, 500);
  } else {
    // 新規追加
    const html = `
            <div class="cart-item" data-price="5200" data-id="${targetId}">
                <div class="cart-item__image"><a href="product.html"><img src="img/product4.jpg" alt="Sparkling"></a></div>
                <div class="cart-item__info">
                    <div class="cart-item__details">
                        <a href="product.html" class="cart-item__name">Purple Reign Sparkling 2023</a>
                        <p class="cart-item__variant">パッケージ: 箱なし</p>
                        <div class="cart-item__price-area">
                            <p class="cart-item__price js-price-text">¥5,200</p>
                            <p class="cart-promo-msg js-promo-msg" style="display:none;"><span style="color:#c0392b; font-size:0.8rem; font-weight:bold;">公式サイト特典: 55%OFF適用</span></p>
                        </div>
                    </div>
                    <div class="cart-item__ctrl">
                        <div class="quantity-selector qty-sm">
                            <button type="button" class="qty-btn" onclick="changeCartQty(this, -1)">-</button>
                            <input type="number" class="js-cart-qty" value="1" min="1" readonly>
                            <button type="button" class="qty-btn" onclick="changeCartQty(this, 1)">+</button>
                        </div>
                        <button class="cart-remove" onclick="removeCartItem(this)">削除</button>
                    </div>
                </div>
                <div class="cart-item__subtotal">¥5,200</div>
            </div>`;
    cartItemsContainer.insertAdjacentHTML('beforeend', html);
  }
  updateCartCalculations();
}

/* =========================================
   Cart Calculations & Logic (割引対応版)
========================================= */
function updateCartCalculations() {
  const items = document.querySelectorAll('.cart-item');
  const shippingThreshold = 12000;
  
  let originalSubtotal = 0; // 割引前の小計
  let finalSubtotal = 0;    // 割引後の合計
  let eligibleSubtotal = 0; // 送料無料の判定に使う金額

  // 1. 各アイテムの計算
  items.forEach(item => {
    // Liquidから渡された属性を取得
    let originalPrice = parseInt(item.getAttribute('data-original-price'));
    let finalPrice = parseInt(item.getAttribute('data-final-price'));
    
    // JSで動的に追加された要素などで属性がない場合のフォールバック（data-price対応）
    if (isNaN(originalPrice) || isNaN(finalPrice)) {
        let fallbackPrice = parseInt(item.getAttribute('data-price'));
        if (isNaN(fallbackPrice)) {
            const priceText = item.querySelector('.js-price-text');
            fallbackPrice = priceText ? parseInt(priceText.textContent.replace(/[^0-9]/g, '')) : 0;
        }
        originalPrice = isNaN(originalPrice) ? fallbackPrice : originalPrice;
        finalPrice = isNaN(finalPrice) ? fallbackPrice : finalPrice;
    }

    const qtyInput = item.querySelector('.js-cart-qty');
    const qty = qtyInput ? parseInt(qtyInput.value) : 1;
    
    const itemOriginalTotal = originalPrice * qty;
    const itemFinalTotal = finalPrice * qty;
    
    // それぞれの合計に加算
    originalSubtotal += itemOriginalTotal;
    finalSubtotal += itemFinalTotal;
    
    // 対象外商品でない場合のみ、送料無料対象額に加算(割引後価格で判定)
    const isExcluded = item.getAttribute('data-no-free-shipping') === 'true';
    if (!isExcluded) {
        eligibleSubtotal += itemFinalTotal;
    }
    
    // 各商品の右端の小計表示を更新（割引後の金額を表示）
    const subDisplay = item.querySelector('.cart-item__subtotal');
    if (subDisplay) {
      subDisplay.textContent = '¥' + itemFinalTotal.toLocaleString();
    }
  });

  // 2. オーダーサマリーの表示更新
  const totalDisplay = document.getElementById('js-total-price');
  if (totalDisplay) {
    totalDisplay.textContent = '¥' + originalSubtotal.toLocaleString(); // 割引前の小計
  }
  
  const finalTotalDisplay = document.getElementById('js-final-total');
  const stickyTotalDisplay = document.getElementById('js-sticky-total');
  if (finalTotalDisplay) {
    finalTotalDisplay.textContent = '¥' + finalSubtotal.toLocaleString(); // 割引後の合計
  }
  if (stickyTotalDisplay) {
    stickyTotalDisplay.textContent = '¥' + finalSubtotal.toLocaleString();
  }

  // 割引額の表示更新 (割引が適用されている場合のみ)
  const discountAmount = originalSubtotal - finalSubtotal;
  const summaryRows = document.querySelectorAll('.summary-row');
  summaryRows.forEach(row => {
      if(row.classList.contains('u-red')) {
          const discountSpan = row.querySelectorAll('span')[1];
          if(discountSpan) {
              discountSpan.textContent = '-¥' + discountAmount.toLocaleString();
          }
      }
  });

  // 3. 送料無料バーの更新
  const barMsg = document.getElementById('js-shipping-msg');
  const barFill = document.getElementById('js-progress-fill');
  const taxNote = document.getElementById('js-tax-note');

  // 送料無料対象外の商品を取得
  const excludedItems = [...document.querySelectorAll('.cart-item[data-no-free-shipping="true"]')];

  if (barMsg && barFill) {
    if (excludedItems.length > 0) {
        // ゲージを非表示にして対象外メッセージを表示
        barFill.parentElement.style.display = 'none';
        const names = excludedItems.map(item => {
            const nameEl = item.querySelector('.cart-item__name');
            return nameEl ? nameEl.textContent.trim() : '一部の商品';
        });
        barMsg.innerHTML = names.map(n => `「${n}」は送料無料対象外です`).join('<br>');
        if (taxNote) {
            taxNote.textContent = taxNote.getAttribute('data-default-text');
        }
    } else if (eligibleSubtotal >= shippingThreshold) {
        barFill.parentElement.style.display = '';
        barMsg.innerHTML = '<strong style="color:#c0392b;">送料無料</strong> が適用されています！';
        barFill.style.width = '100%';
        barFill.style.backgroundColor = '#5e3b6e';
        if (taxNote) {
            taxNote.innerHTML = '<strong style="color:#c0392b;">※送料無料が適用されています</strong>';
        }
    } else {
        barFill.parentElement.style.display = '';
        const diff = shippingThreshold - eligibleSubtotal;
        const percent = Math.min((eligibleSubtotal / shippingThreshold) * 100, 100);
        barMsg.innerHTML = `あと <strong>¥${diff.toLocaleString()}</strong> で送料無料`;
        barFill.style.width = percent + '%';
        barFill.style.backgroundColor = '';
        if (taxNote) {
            taxNote.textContent = taxNote.getAttribute('data-default-text');
        }
    }
  }
}
/* =========================================
   UI Components (Internal)
   ========================================= */
function initHeaderScroll() {
  // ロゴの切り替えは CSS（.logo-base / .logo-scrolled の opacity）が担当する
  const header = document.getElementById('js-header');
  if (!header) return;

  const onScroll = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 50);
  };

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

function initHeroImageSwitch() {
  const heroImg = document.getElementById('js-hero-img');
  if (!heroImg) return;
  const pcImage = 'img/herobg_pc.jpg';
  const spImage = 'img/herobg_sp.jpg';
  const switchImage = () => {
    if (window.innerWidth <= 765) {
      if (!heroImg.src.includes(spImage)) heroImg.src = spImage;
    } else {
      if (!heroImg.src.includes(pcImage)) heroImg.src = pcImage;
    }
  };
  switchImage();
  window.addEventListener('resize', switchImage);
}

function initLoading() {
  const loader = document.getElementById('js-loading');
  if (!loader) return;

  // ▼ 分析ツール（Clarity等 iframe内での表示）対策：即座にローディングを非表示にする
  if (window.self !== window.top) {
    loader.style.display = 'none';
    return;
  }

  // 通常のユーザー向けの処理
  window.addEventListener('load', () => setTimeout(() => loader.classList.add('is-loaded'), 800));
}

function initScrollAnimations() {
  const targets = document.querySelectorAll('.fade-in-up, .fade-in-left, .fade-in-right');

  // ▼ 分析ツール（Clarity等 iframe内での表示）対策：最初から全て表示状態にする
  if (window.self !== window.top) {
    targets.forEach(t => t.classList.add('is-visible'));
    return;
  }

  // 通常のユーザー向けの処理
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -15% 0px' });
  
  targets.forEach(t => observer.observe(t));
}

function initHamburger() {
  const btn = document.getElementById('js-hamburger');
  const nav = document.getElementById('js-nav');
  if (!btn || !nav) return;

  // 見た目は CSS（body.is-nav-open）側で管理する。
  // インラインで position:fixed を当てると、パネルがボタンの上に重なって閉じられなくなるため。
  const openNav = () => {
    btn.classList.add('is-active');
    btn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('is-nav-open');
  };
  const closeNav = () => {
    btn.classList.remove('is-active');
    btn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('is-nav-open');
  };

  btn.addEventListener('click', () => {
    if (btn.classList.contains('is-active')) closeNav();
    else openNav();
  });

  // メニュー内のリンクを押したら閉じる
  nav.querySelectorAll('a').forEach(link => link.addEventListener('click', closeNav));

  // パネルの余白（リンク以外）を押しても閉じる
  nav.addEventListener('click', (e) => {
    if (e.target === nav) closeNav();
  });

  // Esc キーでも閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && btn.classList.contains('is-active')) closeNav();
  });
}

function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) window.scrollTo({ top: target.offsetTop - 80, behavior: 'smooth' });
    });
  });
}

function initCarousel() {
  document.querySelectorAll('.carousel-container').forEach(container => {
    const track = container.querySelector('.carousel-track');
    const prevBtn = container.querySelector('.carousel-btn.prev');
    const nextBtn = container.querySelector('.carousel-btn.next');
    if (!track || !prevBtn || !nextBtn) return;

    const getScrollAmt = () => track.querySelector('.carousel-item')?.offsetWidth + parseFloat(window.getComputedStyle(track).gap || 0) || 0;

    nextBtn.addEventListener('click', () => {
      track.scrollLeft + track.clientWidth >= track.scrollWidth - 5 ? track.scrollTo({ left: 0, behavior: 'smooth' }) : track.scrollBy({ left: getScrollAmt(), behavior: 'smooth' });
    });
    prevBtn.addEventListener('click', () => {
      track.scrollLeft <= 5 ? track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }) : track.scrollBy({ left: -getScrollAmt(), behavior: 'smooth' });
    });
  });
}

function initParallax() {
  const section = document.querySelector('.parallax-section');
  const img = document.getElementById('js-parallax-img');
  if (!section || !img) return;
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;
    const top = section.offsetTop;
    if (scrolled + window.innerHeight > top && scrolled < top + section.offsetHeight) {
      img.style.transform = `translateY(${(scrolled - top) * 0.3}px)`;
    }
  });
}

/* =========================================
   Bundle Restriction (同時購入不可チェック)
   no_bundle タグを持つ商品は他の商品と一緒にカートに入れられない
   ========================================= */
async function checkBundleRestriction(form) {
  // フォーム内の .js-form-meta から data 属性を読み取る
  const meta = form.querySelector('.js-form-meta');
  const adding_is_no_bundle = meta && meta.getAttribute('data-no-bundle') === 'true';
  const adding_title = (meta && meta.getAttribute('data-product-title')) || 'この商品';

  try {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await res.json();

    if (!cart.items || cart.items.length === 0) {
      return { ok: true }; // カート空ならOK
    }

    // カート内に no_bundle 商品があるか調べる
    const no_bundle_in_cart = cart.items.find(item => {
      const tags = (item.product_tags || []).map(t => String(t).toLowerCase());
      return tags.includes('no_bundle');
    });

    if (adding_is_no_bundle) {
      // 単独購入商品を追加しようとしている → カートに何か入っているのでブロック
      return {
        ok: false,
        message: `「${adding_title}」は他の商品と同時にご購入いただけません。\n現在カートに入っている商品を購入手続き後、改めてご注文ください。`
      };
    }

    if (no_bundle_in_cart) {
      // 通常商品を追加しようとしている、カート内に単独購入商品あり → ブロック
      return {
        ok: false,
        message: `カート内の「${no_bundle_in_cart.product_title}」は他の商品と同時にご購入いただけません。\nこの商品を購入手続き後、改めてご注文ください。`
      };
    }

    return { ok: true };
  } catch (e) {
    // 通信失敗時はブロックせず通す（購入機会を損なわないため）
    return { ok: true };
  }
}

/* =========================================
   Add To Cart (Ajax方式)
   ページを丸ごと再読み込みする従来の送信方法だと、Shopifyの計測
   （GA4・Metaピクセル・Google広告に送られる add_to_cart）が発火しない。
   裏側の通信でカートに追加してから、カートページへ移動する。
   ========================================= */
async function addToCartAjax(form) {
  const submitBtn = form.querySelector('[type="submit"]');
  const originalLabel = submitBtn ? submitBtn.innerHTML : '';
  const cartUrl = window.Shopify.routes.root + 'cart';

  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.innerHTML = '追加中…';
  }

  let res;
  try {
    res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    });
  } catch (networkError) {
    // 通信できなかった場合は従来の送信方法にまかせる（購入機会を損なわないため）
    form.submit();
    return;
  }

  if (!res.ok) {
    let message = 'カートに追加できませんでした。時間をおいて再度お試しください。';
    try {
      const data = await res.json();
      message = data.description || data.message || message;
    } catch (e) {}
    alert(message);
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalLabel;
    }
    return;
  }

  // Shopifyの計測イベントが送信されるわずかな時間をおいてから移動する
  setTimeout(() => { window.location.href = cartUrl; }, 150);
}

// すべての .product-form-bundle-check に submit ハンドラを設定
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form.product-form-bundle-check').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const result = await checkBundleRestriction(form);
      if (result.ok) {
        await addToCartAjax(form);
      } else {
        alert(result.message);
      }
    });
  });
});

/* =========================================
   Auto Cart Update (数量変更時の自動更新)
   ========================================= */
function initAutoCartUpdate() {
  const qtyInputs = document.querySelectorAll('.js-cart-qty');
  const updateBtn = document.querySelector('button[name="update"]');

  if (!updateBtn) return;

  qtyInputs.forEach(input => {
    // 数量の数値が変更された時（フォーカスが外れたり、上下矢印を押した時）に発火
    input.addEventListener('change', () => {
      // ユーザーの代わりに裏側で「数量を更新」ボタンをクリックする
      updateBtn.click(); 
    });
  });
}